import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'frame-title',
    template: `
        <ng-content></ng-content>
    `
})

export class FrameTitleComponent implements OnInit {
    constructor() { }

    ngOnInit() { }
}